// Devuelve "2025-04-30 14:05:22"
export function formatDateIsoLike(inputDate) {
  const date = new Date(inputDate);
  return `${date.getFullYear()}-${
    (`00${date.getMonth() + 1}`).slice(-2)}-${
    (`00${date.getDate()}`).slice(-2)} ${
    (`00${date.getHours()}`).slice(-2)}:${
    (`00${date.getMinutes()}`).slice(-2)}:${
    (`00${date.getSeconds()}`).slice(-2)}`;
}

// Devuelve algo como "30 de abril 14:05"
export function formatDateToDisplay(date, lang = 'en') {
  const options = {
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: false,
  };

  return `${new Date(date).toLocaleString(lang, options)}hs.`;
}

// Ejemplo: "martes 30 abril 2025"
export function formatFullDate(date, lang = 'en') {
  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  return new Date(date).toLocaleDateString(lang, options);
}

export function getDefaultSearchDates() {
  const now = new Date();
  const startDate = new Date();
  const endDate = new Date();
  let startHour;

  if (now.getHours() < 15) {
    startHour = now.getHours() + 1;
  } else {
    startHour = 10;
    startDate.setDate(startDate.getDate() + 1);
    endDate.setDate(endDate.getDate() + 1);
  }

  let endHour = startHour + 8;
  if (endHour > 18) {
    endHour = 18;
  }

  startDate.setHours(startHour, 0, 0, 0);
  endDate.setHours(endHour, 0, 0, 0);

  return {
    startDate,
    endDate,
    startHour,
    endHour,
  };
}
